import React from 'react';
import PropTypes from 'prop-types';
import global from '../../stores/GlobalStore';
import _ from 'lodash';
import history from '../../auth/history';
import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';

import ShowDetails from '../Show/ShowDetails';
import ClippList from '../Show/ClippList';
import { stripHtml, formatDescription } from '../../utils/string';

import 'react-activity-feed/dist/index.css';
import './styles/ShowsLandingPage.scss';
import './styles/TimelinePage.scss';
import './styles/ShowPage.scss';

const QUERY_SIZE = 20;
const ASC = 'asc';
const DESC = 'desc';

export default class EpisodePage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      hasMore: true,
      show: this.props.show,
      episode: this.props.episode,
      clipps: [],
      orderBy: DESC,
    };

    this.searchTermRef = React.createRef();
  }

  componentDidMount() {
    const episodeId = this.props.match.params && this.props.match.params.episodeId;

    if (episodeId) {
      this.loadEpisode(episodeId, false);
    } else {
      // Error state?
    }
  }

  componentWillReceiveProps(newProps) {
    const episodeId = this.props.match.params && this.props.match.params.episodeId;
    const newEpisodeId = newProps.match.params && newProps.match.params.episodeId;

    if (episodeId !== newEpisodeId) {
      this.loadEpisode(newEpisodeId, true);
    }
  }

  loadEpisode = (episodeId, forceReload) => {
    global()
      .getPodcastStore()
      .fetchEpisode(episodeId, episode => {
        global()
          .getPodcastStore()
          .getShow(episode.showId, show => {
            const isFollowing = this.props.user && show.followers && show.followers.includes(this.props.user.id);
            this.setState({ show, isFollowing }, () => {
              // TODO: This should alert the user, ask if they want to listen now or add to queue
              if (episode.id !== this.props.episode.id || forceReload) {
                this.setState({ episode });
                this.props.setActiveShow(show);
                this.props.setActiveEpisode(episode);
              }
            });

            this.loadMoreClipps();
          });
      });
  };

  loadMoreClipps = () => {
    const { episode } = this.state;
    const oldClipps = _.clone(this.state.clipps);
    const searchTerm = this.searchTermRef.current && this.searchTermRef.current.value;

    if (episode && episode.id && !searchTerm) {
      setTimeout(() => {
        global()
          .getPodcastStore()
          .fetchClippsForEpisode(
            { episodeId: episode.id, from: oldClipps.length, size: QUERY_SIZE, order: this.state.orderBy },
            (newClipps, meta = {}) => {
              if (newClipps && newClipps.length) {
                const clipps = oldClipps.concat(newClipps);
                this.setState({ clipps, hasMore: true, resultCount: meta.size, isLoading: false });
              } else {
                this.setState({ hasMore: false, resultCount: meta.size, isLoading: false });
              }
            }
          );
      }, 500);
    } else if (episode && episode.id && searchTerm) {
      /*
            setTimeout(() => {
                global().getPodcastStore().searchEpisodesInShow(show.id, searchTerm, oldEpisodes.length, QUERY_SIZE, this.state.orderBy, (newEpisodes, meta) => {
                    if (newEpisodes && newEpisodes.length) {
                        const episodes = oldEpisodes.concat(newEpisodes);
                        this.setState({ episodes: episodes, hasMore: true, resultCount: meta.size, isLoading: false })
                    } else {
                        this.setState({ hasMore: false, resultCount: meta.size, isLoading: false })
                    }
                });
            }, 500);
             */
    }
  };

  searchEpisodesInShow = e => {
    e.preventDefault();

    this.setState({ isLoading: true });
    const searchTerm = this.searchTermRef.current.value;

    global()
      .getPodcastStore()
      .searchEpisodesInShow(this.state.show.id, searchTerm, 0, QUERY_SIZE, this.state.orderBy, (result, meta) => {
        if (meta.size > QUERY_SIZE) {
          this.setState({ isLoading: false, clipps: result, resultCount: meta.size, hasMore: true });
        } else {
          this.setState({ isLoading: false, clipps: result, resultCount: meta.size, hasMore: false });
        }
      });
  };

  searchWatcher = e => {
    e.preventDefault();

    const searchTerm = this.searchTermRef.current.value;

    if (!searchTerm) {
      this.setState({ isLoading: true, episodes: [], resultCount: null, hasMore: true }, () => {
        this.loadMoreClipps();
      });
    }
  };

  toggleSort = () => {
    this.setState({ orderBy: this.state.orderBy === ASC ? DESC : ASC, isLoading: true }, () => {
      this.props.loadMore(this.state.orderBy === ASC ? DESC : ASC);
    });
  };

  redirectToClipp = clipp => {
    history.push(`/_/${clipp.id}`);
    //this.props.setActiveEpisode(episode);
  };

  toggleLoginModal = () => {
    window.dispatchEvent(new CustomEvent('OPEN_LOGIN_MODAL', { detail: {} }));
  };

  followShow = () => {
    if (this.props.user) {
      this.setState({ isFollowing: true });

      global()
        .getPodcastStore()
        .followShow(this.state.show.id, this.props.user.id, result => {
          if (!result) {
            this.setState({ isFollowing: false });
          } else {
            this.setState({ show: result });
          }
        });
    }
  };

  unfollowShow = () => {
    if (this.props.user) {
      this.setState({ isFollowing: false });

      global()
        .getPodcastStore()
        .unfollowShow(this.state.show.id, this.props.user.id, result => {
          if (!result) {
            this.setState({ isFollowing: true });
          } else {
            this.setState({ show: result });
          }
        });
    }
  };

  render() {
    const { user, darkMode, setActiveEpisode, resultCount } = this.props;
    const { isLoading, show, episode, orderBy, clipps, isFollowing } = this.state;

    let isMobile = false;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      isMobile = true;
    }

    return (
      <div className='user-feed'>
        <div
          className='mainPanel episode-panel'
          ref='mainPanel'
          style={{ background: darkMode ? 'rgb(11, 19, 61)' : '' }}
        >
          <div
            className={'show-list-container episode-page' + (isMobile ? ' mobile' : '')}
            style={{
              background: darkMode ? 'rgb(11, 19, 61)' : '',
              borderLeft: darkMode ? '1px solid rgba(255, 255, 255, .2)' : '',
              borderRight: darkMode ? '1px solid rgba(255, 255, 255, .2)' : '',
            }}
          >
            <ShowDetails
              show={show}
              title={episode.title}
              episode={episode}
              user={user}
              isFollowing={isFollowing}
              isEpisode={true}
              toggleLoginModal={this.toggleLoginModal}
              unfollowShow={this.unfollowShow}
              followShow={this.followShow}
            />
            <div style={{ width: '100%' }}>
              {false ? (
                <div className='episode-content'>
                  <div className='episode-title'>{episode.title && stripHtml(episode.title)}</div>
                  <div
                    className='episode-description'
                    dangerouslySetInnerHTML={{ __html: formatDescription(episode.description) }}
                  />
                </div>
              ) : (
                <Tabs defaultTab={'details'}>
                  <TabList>
                    <Tab tabFor='details'>Episode Details</Tab>
                    <Tab tabFor='clipps'>Episode Clipps</Tab>
                  </TabList>
                  <TabPanel tabId='details'>
                    <div className='episode-content'>
                      <div className='episode-title'>{episode.title && stripHtml(episode.title)}</div>
                      <div
                        className='episode-description'
                        dangerouslySetInnerHTML={{ __html: formatDescription(episode.description) }}
                      />
                    </div>
                  </TabPanel>
                  <TabPanel tabId='clipps'>
                    <ClippList
                      user={user}
                      isLoading={isLoading}
                      show={show}
                      episode={episode}
                      items={clipps}
                      setActiveItem={setActiveEpisode}
                      loadMore={this.loadMoreClipps}
                      searchFunc={this.loadMoreClipps}
                      redirectTo={this.redirectToClipp}
                      searchWatcher={this.searchWatcher}
                      searchTermRef={this.searchTermRef}
                      resultCount={resultCount}
                      itemName='Clipp'
                      orderBy={orderBy}
                    />
                  </TabPanel>
                </Tabs>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

EpisodePage.propTypes = {
  user: PropTypes.object,
  show: PropTypes.object,
  episode: PropTypes.object.isRequired,
  setActiveEpisode: PropTypes.func.isRequired,
  darkMode: PropTypes.bool,
};

EpisodePage.defaultProps = {
  episode: {},
  show: {},
};
